var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDdxAiMessageLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V32H8C3.58172 32 0 28.4183 0 24V8Z",
    fill: "#22003C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9888 22.022C18.6451 22.022 13.6513 24.1485 11.8224 25.2117C10.3512 25.9408 9.77808 24.9079 9.67543 24.3004C9.67543 19.1968 7.44887 14.4274 6.33559 12.6807C5.76306 11.587 6.57415 10.8579 7.05126 10.6301C13.54 10.2656 17.8658 8.19985 19.2176 7.21256C20.9352 6.66575 21.5237 7.74418 21.6032 8.35175C21.7941 13.273 24.0683 18.3007 25.1816 20.1993C25.7541 21.4752 24.6249 21.9461 23.9888 22.022Z",
    stroke: "#7742FE",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8423 25.8209C13.4262 22.1247 8.69379 20.0938 6.75457 19.5404C5.28603 19.0108 5.66773 17.923 6.04214 17.4453C9.73837 14.0293 11.7692 9.29684 12.3226 7.35761C12.7486 6.22958 13.7952 6.30261 14.2652 6.48013C18.6772 10.7244 22.9387 12.3339 24.5179 12.6081C26.0119 13.4302 25.607 14.5591 25.2179 15.0207C21.7756 18.4468 19.5883 23.3851 18.9249 25.4259C18.3668 26.676 17.3039 26.2101 16.8423 25.8209Z",
    stroke: "#7742FE",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDdxAiMessageLogo);
export default __webpack_public_path__ + "static/media/ddx-ai-message-logo.b51a9e7d560315d2b89b48cc2181deee.svg";
export { ForwardRef as ReactComponent };